import { useOutletContext } from "react-router-dom";
import logo from "../utils/sanfer-mx.png";
import "../styles/Presentacion.css";
import { APP_VERSION } from "../helpers/constants";


const Presentacion = () => {
  const { user } = useOutletContext();

  return (
    <div className="presentacion-container">
      <h1>¡HOLA!</h1>
      <h2>{user ? user.name : "Usuario"}</h2>

      {user?.role_id > 0 ? (
        <>
          <p>Bienvenid@ a la plataforma</p>
          <p>Reservaciones Sanfer Almacén</p>

          <div className="info-panel">
            <h3>📋 ¿Dónde encuentro mis citas?</h3>
            <ul>
              <li><strong>Pendientes:</strong> Citas activas que aún no han sido atendidas y cuya fecha es de hoy en adelante.</li>
              <li><strong>Calendario:</strong> Vista por almacén y día de todas las citas agendadas.</li>
              <li><strong>Todas:</strong> Historial completo. Usa los filtros <em>Externas</em>, <em>Internas</em> y <em>Pasadas</em> para consultar citas anteriores, canceladas o completadas.</li>
            </ul>
          </div>
        </>
      ) : (
        <p>Contacta al administrador para obtener acceso.</p>
      )}
      <img src={logo} alt="80 Aniversario Sanfer" className="anniversary-logo" />
      <footer>
        <p>Versión {APP_VERSION} · Reservaciones Sanfer Almacén</p>
      </footer>
    </div>
  );
};

export default Presentacion;